import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import AppPropTypes from '../../../proptypes/AppPropTypes';
import { buildQueryString } from '../../../utils/url';
import ThemedLink from '../../themedLink/ThemedLink';
import Checkbox from '../../checkbox/Checkbox';

export const CustomCellComponent = ({
  allData,
  checkBy,
  classes,
  data,
  fieldName,
  hide,
  isBlank,
  isCheckbox,
  isEllipsis,
  linkCls,
  linkParams,
  linkUrl,
  onRowClick,
  value,
  valueFormatted
}) => {
  const val = fieldName || valueFormatted || value;
  const button = () => (
    <ThemedLink
      onClick={/* istanbul ignore next */ () => onRowClick(data)}
      role="link"
      tabIndex="0"
      data-qa="grid-link"
    >
      {val}
    </ThemedLink>
  );
  const CustomCheckbox = () => (
    <Checkbox
      onClick={/* istanbul ignore next */ () => onRowClick(data, allData)}
      checked={!!allData.find((x) => x === data[checkBy])}
    />
  );

  const link = () => {
    const props = { target: (isBlank && '_blank') || '' };
    const keys = Object.keys(linkParams);
    const params = keys
      .map((k) => {
        const match = data[k];

        return {
          [(match && linkParams[k].key) || k]: match || data[linkParams[k]] || linkParams[k]
        };
      })
      .reduce((acc, o) => ({ ...acc, ...o }), {});

    return (
      <ThemedLink
        bare
        className={linkCls}
        to={`${linkUrl}?${buildQueryString(params)}`}
        {...props}
      >
        {val}
      </ThemedLink>
    );
  };

  const Element = linkUrl ? link : button;

  if (isEllipsis) {
    return <div title={val}>{val}</div>;
  }

  return (
    !(hide && hide(data)) && (
      <div className={classnames('override-for-glu-grid', classes.amountCell)}>
        {isCheckbox ? <CustomCheckbox /> : <Element />}
      </div>
    )
  );
};

CustomCellComponent.propTypes = {
  classes: AppPropTypes.jssClasses,
  data: PropTypes.shape({}),
  hide: PropTypes.func,
  value: PropTypes.string,
  onRowClick: PropTypes.func,
  fieldName: PropTypes.string,
  linkUrl: PropTypes.string,
  checkBy: PropTypes.string,
  linkCls: PropTypes.string,
  linkParams: PropTypes.shape({}),
  isBlank: PropTypes.bool,
  isEllipsis: PropTypes.bool
};

CustomCellComponent.defaultProps = {
  onRowClick() {},
  classes: {},
  data: {},
  hide: null,
  value: null,
  fieldName: '',
  linkUrl: '',
  checkBy: '',
  linkCls: '',
  linkParams: null,
  isBlank: false,
  isEllipsis: false
};

export default CustomCellComponent;
